// RouterIndex.tsx
import React, { FC } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import MainOutlet from '../../../layout-controller-mod/layout-serv/outlet/ts/main-outlet/mainOutlet';
import SettingOutlet from '../../../layout-controller-mod/layout-serv/outlet/ts/setting-oulet/settingOutlet';
import ContentMainPage from '../../../page-controller-mod/page-serv/content/main-content/ts/contentMainPage';
import MediaPage from '../../../page-controller-mod/page-serv/media/media-card-page/ts/mediaPage';
import { PermissionRoute } from '../route-private/permissionRoute';
import {
  permissionIsAccessCMSCareer,
  permissionIsAccessCMSContent,
  permissionIsAccessCMSInbox,
  permissionIsAccessCMSMedia,
  permissionIsAccessCMSNotification,
  permissionIsAccessCMSOverview,
  permissionIsAccessCMSSetting,
  permissionIsAccessCMSWorkflow,
  permissionName,
} from '../../../context-controller-mod/context-serv/permission-provider/permissionExporter';
import AnalyticsSet from '../../../page-controller-mod/page-serv/settings/analytic-set/ts/setting-analytic';
import ApplicationSet from '../../../page-controller-mod/page-serv/settings/application-set/ts/setting-applicaiton';
import MediaMgtSet from '../../../page-controller-mod/page-serv/settings/media-management-set/ts/setting-media-mgt';
import NotificationSet from '../../../page-controller-mod/page-serv/settings/notification-set/ts/setting-notification';
import SubmissionSet from '../../../page-controller-mod/page-serv/settings/general-set/ts/setting-submission';
import AttahcmentSet from '../../../page-controller-mod/page-serv/settings/workflow-set/ts/setting-attachment';
import DashboardPage from '../../../page-controller-mod/page-serv/dashboard/ts/dashboardPage';
import InboxUi from '../../../page-controller-mod/page-serv/inbox/ts/inbox';
import HireUi from '../../../page-controller-mod/page-serv/career/ts/hire/hire';
import SubmitUi from '../../../page-controller-mod/page-serv/career/ts/submit/submit';
import { PrivateRoute } from '../route-private/privateRoute';
import NotificationPage from '../../../page-controller-mod/page-serv/notification/ts/notificationPage';
import HireCreate from '../../../page-controller-mod/page-serv/career/ts/hire/hire-create';
import HireView from '../../../page-controller-mod/page-serv/career/ts/hire/hire-view';
import HireEdit from '../../../page-controller-mod/page-serv/career/ts/hire/hite-edit';
import ContentEditPage from '../../../page-controller-mod/page-serv/content/edit-content/default-edit-page/ts/contentEditPage';
import WorkflowUi from '../../../page-controller-mod/page-serv/workflow/ts/workflow-ui';
import PreviewLocal from '../../../page-controller-mod/page-serv/workflow/ts/preview-local';
import ForbiddenPage from '../route-private/forbiddenPage';
import { useFallbackRoute } from '../route-private/useFallbackRoute.type';
import { PermissionProvider } from '../../../context-controller-mod/context-serv/permission-provider/permissionProvider';
import { ToastProvider } from '../../../context-controller-mod/context-serv/toast-provider/bottomToast/ts/ToastProvider';
import { GlobalPopupProvider } from '../../../context-controller-mod/context-serv/popup-provider/ts/globalPopupProvider';
import { RightSidebarProvider } from '../../../context-controller-mod/context-serv/global-provider/right-sidebar-provider/ts/right-sidebar-context';
import { EditModeProvider } from '../../../context-controller-mod/context-serv/global-provider/dirty-provider/dirtyModeProvider';

const AUTH_URL = `${process.env.REACT_APP_URL_AUTHENTICATION}`;
const URL_AUTHEN = `${AUTH_URL}/login`;

const DefaultRedirect: FC = () => {
  const { fallback, loading } = useFallbackRoute();
  /* istanbul ignore next */
  if (loading || !fallback) /* istanbul ignore next */ return null;
  return <Navigate to={fallback} replace />;
};

const RouterIndex: FC = () => {
  return (
    <Router>
      <Routes>

        <Route path="/" element={
          <PrivateRoute loginUrl={URL_AUTHEN}>
            <PermissionProvider>
              <ToastProvider>
                <GlobalPopupProvider>
                  <RightSidebarProvider>
                    <EditModeProvider>
                      <MainOutlet />
                    </EditModeProvider>
                  </RightSidebarProvider>
                </GlobalPopupProvider>
              </ToastProvider>
            </PermissionProvider>
          </PrivateRoute>
        }>
          <Route index element={<DefaultRedirect />} />


          <Route path="/forbidden" element={<ForbiddenPage />} />

          {/* Overview */}
          <Route path="/overview"
            element={
              <PermissionRoute
                element={<DashboardPage />}
                resource={permissionName}
                permission={`${permissionIsAccessCMSOverview}`}
                action="view-only"
              />
            }
          />

          {/* Content */}
          <Route path="/content">
            <Route index element={<Navigate to="company" />} />
            <Route path=":contentType"
              element={
                <PermissionRoute
                  element={<ContentMainPage />}
                  resource={permissionName}
                  permission={`${permissionIsAccessCMSContent}`}
                  action="view-only"
                />
              }
            />
            <Route
              path=":contentType/:contentUuid/:contentVersionUuid/:sectionId/edit"
              element={<ContentEditPage />}
            />
          </Route>

          {/* Media */}
          <Route path="/media"
            element={
              <PermissionRoute
                element={<MediaPage />}
                resource={permissionName}
                permission={`${permissionIsAccessCMSMedia}`}
                action="view-only"
              />
            }
          />

          {/* Career */}
          <Route path="/career"
            element={
              <PermissionRoute
                element={<Outlet />}
                resource={permissionName}
                permission={permissionIsAccessCMSCareer}
                action="view-only"
              />
            }
          >
            <Route index element={<Navigate to="hire" />} />
            <Route path="hire" element={<HireUi />} />
            <Route path="hire/create" element={<HireCreate />} />
            <Route path="hire/:careerId/view" element={<HireView />} />
            <Route path="hire/:careerId/edit" element={<HireEdit />} />
            <Route path="submit" element={<SubmitUi />} />
          </Route>

          {/* Inbox */}
          <Route path="/inbox"
            element={
              <PermissionRoute
                element={<InboxUi />}
                resource={permissionName}
                permission={permissionIsAccessCMSInbox}
                action="view-only"
              />
            }
          />

          {/* Workflow */}
          <Route path="/workflow"
            element={
              <PermissionRoute
                element={<Outlet />}
                resource={permissionName}
                permission={permissionIsAccessCMSWorkflow}
                action="view-only"
              />
            }
          >
            <Route index element={<Navigate to="manage" />} />
            <Route path="manage" element={<WorkflowUi />} />
            <Route path="manage/preview/:currentId/:versionId/:mode" element={<PreviewLocal />} />
          </Route>

          {/* Notification */}
          <Route path="/notification"
            element={
              <PermissionRoute
                element={<NotificationPage />}
                resource={permissionName}
                permission={permissionIsAccessCMSNotification}
                action="view-only"
              />
            }
          />

          {/* Setting */}
          <Route path="/setting"
            element={
              <PermissionRoute
                element={<SettingOutlet />}
                resource={permissionName}
                permission={permissionIsAccessCMSSetting}
                action="view-only"
              />
            }
          >
            <Route index element={<Navigate to="digital-asset" />} />
            <Route path="digital-asset" element={<MediaMgtSet />} />
            <Route path="submission" element={<SubmissionSet />} />
            <Route path="alert-configuration" element={<NotificationSet />} />
            <Route path="application" element={<ApplicationSet />} />
            <Route path="analytics" element={<AnalyticsSet />} />
            <Route path="attachments" element={<AttahcmentSet />} />
          </Route>

        </Route>

        <Route path="*" element={<DefaultRedirect />} />

      </Routes>
    </Router>
  );
};

export default RouterIndex;